import type { ReactNode } from 'react';

export type BadgeTone = 'bien' | 'atencion' | 'mal' | 'neutro' | 'marca';

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  /** Punto de color delante del texto, para reforzar el semaforo. */
  dot?: boolean;
  title?: string;
}

export function Badge({
  tone = 'neutro',
  children,
  dot = false,
  title,
}: BadgeProps): JSX.Element {
  return (
    <span className={`badge badge--${tone}`} title={title}>
      {dot && <span className="badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

/** Traduce el estado de un precio a un tono del semaforo. */
export function pricingTone(status: 'ok' | 'ajustado' | 'infraprecio'): BadgeTone {
  if (status === 'ok') return 'bien';
  if (status === 'ajustado') return 'atencion';
  return 'mal';
}

export const PRICING_LABEL: Record<'ok' | 'ajustado' | 'infraprecio', string> = {
  ok: 'En objetivo',
  ajustado: 'Ajustado',
  infraprecio: 'Infraprecio',
};
